<template>
  <div class="rounded">
    <vue-flux
      :options="vfOptions"
      :images="urls"
      :transitions="vfTransitions"
      ref="slider"
    >
      <template v-slot:controls>
        <flux-controls />
      </template>

      <template v-slot:index>
        <flux-index />
      </template>
    </vue-flux>
  </div>
</template>

<script>
import sanityImageBuilder from "../utils/sanityImageBuilder";
import { VueFlux, FluxControls, FluxIndex} from "vue-flux";

export default {
  name: "RichTextGallery",
  props: {
    _sanityProps: {
      type: Object
    },
    images: {
      type: Array
    }
  },
  components: {
    VueFlux,
    FluxControls,
    FluxIndex,
  },
  data() {
    return {
      vfOptions: {
        autoplay: false
      },
      vfTransitions: [
        {
          name: "slide",
          options: {
            totalDuration: 1400,
            easing: "ease-in-out"
          }
        }
      ],
      urls: []
    };
  },
  created() {
    this.urls = this.images.map(img => {
      return sanityImageBuilder
        .image(img)
        .url();
    });
  }
};
</script>

<style scoped></style>
